

$(document).ready(function(){

    var selector = 'js-pipe-action';

    var rootKey = 'root';

    var activeClass = 'active';

    var dataSelectorAttr = 'data-pipe-content';

    var contentClass = 'pipe-content-block';


    var pipe = $('.pipe');

    var mainSide = pipe.find('.pipe__main');

    var leftParent = $('.pipe__main__in');
    var rightParent = $('.pipe__side__in');

    let sleep = function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    let displayContent = async function(key, target) {

        if(target){
            history.pushState(null, null, target);
        }

        //wait to slide
        if(rootKey === key){
             pipe.removeClass('invert');

        }
        else{
            pipe.addClass('invert');
        }


        var splitKey = key.split('/');

        var subkey = splitKey[1] ? splitKey[1] : '';

        key = splitKey[0];

        var newLeft = leftParent.find('['+ dataSelectorAttr +'="'+ key +'"]');
        var newRight = rightParent.find('['+ dataSelectorAttr +'="'+ key +'"]');


        await sleep(400);

        $('.'+ contentClass +'.' + activeClass).animate({opacity:0}, 200, 'swing', function() {

            $(this).removeClass(activeClass);

            newLeft.css({opacity:0}).addClass(activeClass);
            newLeft.animate({opacity:1}, 400, 'swing');

            newRight.css({opacity:0}).addClass(activeClass);

            if(subkey) {
                newRight.find('.' + contentClass).removeClass(activeClass);

                let sub = newRight.find('['+ dataSelectorAttr +'="'+ subkey +'"]');

                sub.css({opacity:1});
                sub.addClass(activeClass);

            }

            newRight.animate({opacity:1}, 400, 'swing');
        });

    }

    $('body').on('click', '['+ selector +']', function (e) {

        e.preventDefault();

        var target = $(this).attr('href');
        var key = $(this).attr(selector);

        displayContent(key, target);

    });


    $('body').on('click', '.chat-close', function (e) {
        e.preventDefault();
    });


    addEventListener('popstate', function (e) {
        //remove first and last /
        var path = window.location.pathname.replace(/^\/+|\/+$/g, '');

        var pathArr = path.split('/');


        if(1 === pathArr.length){
            displayContent(rootKey);
            return;
        }

        if(2 === pathArr.length){
            displayContent(pathArr[1]);
            return;
        }

        pathArr.shift();

        displayContent(pathArr.join('/'));

    });




});